module.exports = __webpack_public_path__ + "img/__icon_PODKONTENEROWA_STANDARD_20.3524a4aa.svg";